import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

/**
 * Temporary mapper from a numeric taxonomy id to the v3 selection object.
 * TODO: Replace magic ranges with data-driven mapping from selection lists.
 */
export function mapTaxonomyIdToSelection(
  newTaxonomyId: number
): CustomRoleTaxonomySelection | { default: true } {
  if (newTaxonomyId === 0 || Number.isNaN(newTaxonomyId)) {
    return { default: true };
  }

  if (newTaxonomyId >= 1 && newTaxonomyId <= 50) {
    return { ricsK50Id: String(newTaxonomyId) };
  }
  if (newTaxonomyId >= 51 && newTaxonomyId <= 60) {
    return { ricsK10Id: String(newTaxonomyId - 50) };
  }

  if (newTaxonomyId > 60) {
    return { taxonomyId: newTaxonomyId };
  }

  return { default: true };
}

/**
 * Inverse mapper from CustomRoleTaxonomySelection to numeric taxonomy ID.
 */
export function mapRoleTaxonomySelectionToId(
  selection: CustomRoleTaxonomySelection | { default: true }
): number {
  if ('default' in selection && selection.default) {
    return 0;
  }

  if ('taxonomyId' in selection && typeof selection.taxonomyId === 'number') {
    return selection.taxonomyId;
  }

  if ('ricsK50Id' in selection && selection.ricsK50Id) {
    return Number(selection.ricsK50Id);
  }

  if ('ricsK10Id' in selection && selection.ricsK10Id) {
    return Number(selection.ricsK10Id) + 50;
  }

  return 0; // Default fallback
}
